module.exports = __webpack_public_path__ + "static/media/IMG_3479_sm.3ddc919b.jpg";